module.exports = __webpack_public_path__ + "996004e85840bb79ce9ad3788a05e76a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/sso/view/home/images/ssobg.png
// module id = 436
// module chunks = 0